export default [{
    path: 'trainIndex',
    name: '规划师培训',
    meta: {
        showFooter: true
    },
    component: () => import('../../views/train/index.vue')
}];
